module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_07-37c96cf1e99c3bb60ee93eb0d16356ab.jpg";